import React, { Fragment } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
// import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'
// import NProgress from 'nprogress'
import { Helmet } from 'react-helmet'
import OauthCallback from 'pages/auth/oauthCallback/index'
import { getCookie } from 'helpers'
import {
  getSessionIdFromUrl,
  isValidSessionId,
  storeSessionId,
} from 'utils/cliAuthSession'
import PublicLayout from './Public'
import AuthLayout from './Auth'
import MainLayout from './Main'
import constants from '../constants'
import cometchatIcon from '../assets/cometchat/images/logo-new.svg'

const Layouts = {
  public: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
}

@withRouter
@connect(({ user, apps, settings }) => ({ user, apps, settings }))
class Layout extends React.PureComponent {
  state = { pageLoadEventCalled: false }

  previousPath = ''

  componentDidMount() {
    const {
      location: { pathname },
    } = this.props

    // CLI Auth: detect sessionId from URL on initial load
    this.detectAndHandleCliAuthSession()

    window.CometChatReady = () => {
      if (window.CometChatAnalytics.load !== undefined && pathname !== '/') {
        const { pageLoadEventCalled } = this.state
        if (!pageLoadEventCalled) {
          this.setState({ pageLoadEventCalled: true })

          window.CometChatAnalytics.load()
        }
      }
      window.userData = JSON.parse(localStorage.getItem('userData'))
    }
  }

  componentDidUpdate(prevProps) {
    const {
      location: { pathname, search },
    } = this.props
    const {
      location: { pathname: prevPathname, search: prevSearch },
    } = prevProps
    if (pathname !== prevPathname) {
      window.scrollTo(0, 0)
    }

    // CLI Auth: detect sessionId when URL changes (e.g., already logged in user navigates with ?sessionId=)
    if (search !== prevSearch) {
      this.detectAndHandleCliAuthSession()
    }

    if (JSON.parse(localStorage.getItem('userData')) !== window.userData)
      window.userData = JSON.parse(localStorage.getItem('userData'))
    const { pageLoadEventCalled } = this.state

    if (
      !pageLoadEventCalled &&
      pathname !== '/' &&
      window.CometChatAnalytics !== undefined &&
      window.CometChatAnalytics.load !== undefined
    ) {
      window.CometChatAnalytics.load()
      this.handlePageLoadEventCalled()
    }

    if (
      constants.captureGTMEvents &&
      window.CometChatAnalytics !== undefined &&
      prevPathname !== undefined &&
      prevPathname !== pathname &&
      prevPathname !== '/' &&
      pathname !== '/'
    ) {
      if (window.CometChatAnalytics) window.CometChatAnalytics.page()
    }
  }

  handlePageLoadEventCalled = () => {
    this.setState({ pageLoadEventCalled: true })
  }

  detectAndHandleCliAuthSession = () => {
    const { user, dispatch } = this.props
    const urlSessionId = getSessionIdFromUrl()
    if (urlSessionId && isValidSessionId(urlSessionId)) {
      storeSessionId(urlSessionId)
      // If user is already authenticated, trigger association immediately
      if (user.authorized && localStorage.getItem('ccBearerToken')) {
        dispatch({ type: 'user/CLI_AUTH_ASSOCIATE' })
      }
      // If not authenticated, sessionId is stored in localStorage and will be picked up
      // by LOAD_CURRENT_ACCOUNT after login/signup completes
    }
  }

  render() {
    const {
      children,
      location: { pathname }, // search
      user,
      settings,
    } = this.props
    // NProgress Management
    // const currentPath = pathname + search
    // if (currentPath !== this.previousPath) {
    //   NProgress.start()
    // }

    // setTimeout(() => {
    //   NProgress.done()
    //   // this.previousPath = currentPath
    //   apps.loading = false
    // }, 300)

    // Layout Rendering

    const getLayout = () => {
      if (['/', '/cli-auth/success'].includes(pathname)) {
        return 'public'
      }

      if (
        [
          '/login',
          '/verify-account',
          '/signup',
          '/register',
          '/forgot-password',
          '/reset-password-email-sent',
          '/verification-email-sent',
          '/create-your-first-application',
          '/schedule-your-kick-off-call',
          '/sso-complete',
          '/token/:id',
        ].includes(pathname) ||
        pathname.indexOf('/reset/password/') >= 0 ||
        pathname.indexOf('/verify/email/') >= 0 ||
        pathname.indexOf('/invite/collaborator/') >= 0
      ) {
        return 'auth'
      }
      return 'main'
    }

    const Container = Layouts[getLayout()]
    const isUserAuthorized = user.authorized
    const isUserLoading = user.loading
    const isAuthLayout = getLayout() === 'auth'

    const isPublicCliAuthPage = pathname === '/cli-auth/success'

    const BootstrappedLayout = () => {
      // show loader when user in check authorization process, not authorized yet and not on login pages
      if (isUserLoading && !isUserAuthorized && !isAuthLayout && !isPublicCliAuthPage) {
        return null
      }

      // redirect to login page if current is not login page and user not authorized
      if (!isAuthLayout && !isUserAuthorized && !isPublicCliAuthPage) {
        if (['sso-complete'].includes(pathname)) {
          return <Redirect to={pathname} />
        }
        // if (['/signup', '/register'].includes(pathname)) {
        //   return <Redirect to="/login" />
        // }
        if (
          ['/login'].includes(pathname) ||
          ['/verify-account'].includes(pathname) ||
          (user.actionLogout !== undefined && user.actionLogout)
        ) {
          return <Redirect to={pathname} />
        }

        // Check for OAuth code in search parameters
        const params = new URLSearchParams(window.location.search)
        const code = params.get('code')

        if (code || window.location.href.includes('/?code=')) {
          return <OauthCallback />
        }

        const hasAccount = getCookie && getCookie('dashboard_account')
        if (hasAccount && pathname !== '/login') {
          return <Redirect to="/login" />
        }

        return <Redirect to="/signup" />
      }
      // in other case render previously set layout

      if (settings && (settings.isMobileView || settings.isMobileXSView)) {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100vh',
              textAlign: 'center',
              flexDirection: 'column',
              gap: '20px',
            }}
          >
            <img
              style={{ width: '128px', fontSize: '600px' }}
              src={cometchatIcon}
              alt="CometChat"
            />
            This dashboard is accessible only on desktop devices. Please switch to a larger screen
            for the best experience.
          </div>
        )
      }

      return <Container>{children}</Container>
    }

    return (
      <Fragment>
        <Helmet titleTemplate="%s | CometChat" />
        {BootstrappedLayout()}
      </Fragment>
    )
  }
}

export default Layout
